export const getOrder = (orders, id) => orders.find((o) => o.orderID === parseInt(id, 10));
export const getLicense = (licenses, id) => licenses.find((l) => l.licenseID === parseInt(id, 10));
